var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeluxeHydrafacial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2836 6.54962V17.1866",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2836 30.482V41.119",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5693 23.8339H30.9321",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6373 23.8339H7.00002",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5063 11.6127L28.9839 19.1349",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5848 28.5336L12.0624 36.0558",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5063 36.0558L28.9839 28.5336",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5848 19.1349L12.0624 11.6127",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0398 23.6793C30.5354 22.5752 28.4501 18.2114 25.0223 13.4135C24.7212 12.9945 24.0939 12.9945 23.7953 13.4135C20.365 18.2114 18.2797 22.5752 17.7754 23.6793C17.281 24.673 17 25.7796 17 26.964C17 31.0542 20.3173 34.3641 24.4076 34.3641C28.4978 34.3641 31.8151 31.0542 31.8151 26.964C31.8151 25.7796 31.5341 24.673 31.0398 23.6793Z",
    fill: "#A0CFDC",
    stroke: "#A0CFDC",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0398 23.6793C30.5354 22.5752 28.4501 18.2114 25.0224 13.4135C24.7213 12.9945 24.0939 12.9945 23.7953 13.4135C20.365 18.2114 18.2798 22.5752 17.7754 23.6793C17.281 24.673 17 25.7796 17 26.964C17 31.0542 20.3174 34.3641 24.4076 34.3641C28.4978 34.3641 31.8152 31.0542 31.8152 26.964C31.8152 25.7796 31.5341 24.673 31.0398 23.6793Z",
    fill: "#A0CFDC",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7521 28.063C19.7772 28.8986 20.0858 29.7292 20.6881 30.3967C21.5312 31.3327 22.7508 31.7317 23.9101 31.5711",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeluxeHydrafacial);
export default __webpack_public_path__ + "static/media/deluxe-hydrafacial.1a34029b94fb9cca591de14849ae1bda.svg";
export { ForwardRef as ReactComponent };